import { useUserContext } from '../context/UserContext';
import { userTypes, themes } from '../app/enums';
import { Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    manheimLocationTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(1, 1), 
      backgroundColor: '#FFFFFF',
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
    locationTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(1, 1),
      backgroundColor: theme.palette.secondary.dark,
    },
    whiteText: {
      color: '#FFFFFF',
      fontWeight: 'bold',
    }
  }),
);

export const ToolbarLocation = () => {
  const { state } = useUserContext();
  const classes = useStyles();

  if(state.self.locations === undefined 
    || state.self.userType === userTypes.INTERNAL 
    || state.self.userType === '-1'){
    return (<div></div>);
  }

  return (
    <div>
    { state.userTheme === themes.DEFAULT
        ? <div className={classes.locationTitle}>
            <Typography variant="h6" noWrap className={classes.whiteText}>
              {state.self.locations[0].name}
            </Typography>
          </div>
        : <div>
            <Typography variant="h6" noWrap className={classes.manheimLocationTitle}>
              {state.self.locations[0].name}
            </Typography>
          </div>
    }
    </div>
  );
};

export default ToolbarLocation;

